import React from "react";
import classes from "./LoginWithPhoneOTP.scss";
import CheckOTP from "../CheckOTP/CheckOTP";
import { onEnterOrSpaceKeyDown } from "Utils";
import { useI18n } from "Hooks";

const confirmBtnStyle = { marginTop: 0 };

const LoginWithPhoneOTP = props => {
  const {
    generateOtpForSignIn,
    customStyle = {},
    renderBackButtonComponent,
    data: { phoneNo, otp } = {},
    updateCurrentScreen,
    updateInputField,
    isLoading,
    verifyParentOTPForSignIn,
  } = props;
  const { t } = useI18n(["common"]);

  const onResendClick = () => {
    updateInputField({ otp: "" });
    generateOtpForSignIn();
  };

  const onConfirmClick = () => {
    verifyParentOTPForSignIn();
  };

  const onBackClick = () => {
    updateCurrentScreen({ type: "parentLoginForm" });
    updateInputField({});
  };

  const subText = (
    <span>
      We just texted a six-digit code to{" "}
      <span className={classes.phoneText}>{phoneNo ? `+${phoneNo}` : ""}</span>
      {`. Enter the code below to sign in. `}
      <span
        className={classes.resendButton}
        onClick={onResendClick}
        onKeyDown={e =>
          onEnterOrSpaceKeyDown(e, () => onResendClick && onResendClick(e))
        }
        role="button"
        tabIndex={0}
        aria-label={t("common:resend_code", { defaultValue: "Resend code" })}
      >
        Resend Code
      </span>
    </span>
  );

  return (
    <CheckOTP
      renderBackButtonComponent={renderBackButtonComponent}
      onBackClick={onBackClick}
      onConfirmClick={onConfirmClick}
      customStyle={{ ...customStyle, confirmBtnStyle }}
      isLoading={isLoading}
      heading={`Verify OTP`}
      subHeading={subText}
      phoneNo={phoneNo}
      otp={otp}
      onResendClick={onResendClick}
      updateInputField={updateInputField}
    />
  );
};

export default LoginWithPhoneOTP;
